import React, {useState, useEffect, useRef, useContext} from 'react';
import axios from "axios";

import Pagina0 from "./formulario/Pagina0";
import Pagina1 from "./formulario/Pagina1";
import Pagina2 from "./formulario/Pagina2";
import Pagina3 from "./formulario/Pagina3";
import Pagina4 from "./formulario/Pagina4";
import Pagina1b from "./formulario/Pagina1b";

import '../css/sismo_sentido.css';

import ConsultaPorSitio from './consulta_por_sitio/ConsultaPorSitio';
import SelectorResultadosSismo from './resultados/SelectorResultadosSismo';
import Contexto from './comun/Contexto';
import Gracias from './formulario/Gracias';
import { buscarPagina } from './comun/Pagina';
import PaginaArchivos from './formulario/PaginaArchivos';

/* Constantes globales */
export const NAV_SELECTOR_RESULTADOS_SISMO = "NAV_SELECTOR_RESULTADOS_SISMO";
export const NAV_RESULTADOS = "NAV_RESULTADOS";
export const NAV_CONSULTA_SITIO = "NAV_CONSULTA_SITIO";

/**
 * Componente principal, encargado de la navegacion.
 */
export default function SismoSentido () {
    /* Contexto */
    const { urlBaseRest } = useContext(Contexto);
    console.log("SismoSentido urlBaseRest: " + urlBaseRest);

    /* Estado */        
    const [idPagina, setIdPagina] = useState(0);

    // datos a enviar
    const [idSismo, setIdSismo] = useState(null);    
    const [direccion, setDireccion] = useState(null);
    const [piso, setPiso] = useState(null);
    const [state, setState] = useState({});
    const [estadoFinal, setEstadoFinal] =useState({});
    const [idDepto, setIdDepto] = useState(-1);
    const idDeptoRef = useRef(-999);
    const [idMun, setIdMun] = useState(-1);
    const idMunRef = useRef(-999);
    const [idCP, setIdCP] = useState(-1);

    const avanzarPagina = () => {
        setIdPagina(parseInt(idPagina)+1);
    }
    
    const retrocederPagina = () => {
        setIdPagina(parseInt(idPagina)-1);
    }

    const irASelectorResultados = () => {
        setIdPagina(NAV_SELECTOR_RESULTADOS_SISMO);
    }

    const irAConsultaSitio = () => {
        setIdPagina(NAV_CONSULTA_SITIO);
    }

    const irAPaginaAlterna =()=>{
        setIdPagina("1b");
    }

    const avanzarPaginaAlt = () => {
        setIdPagina(1);
    }
    
    const irAPagina0 = () => {
        setIdPagina(0);
    }

    const reiniciarFormulario = ()=> {
        setIdSismo(null);    
        setDireccion(null);
        setPiso(null);
        setState({});
        setEstadoFinal({});
        setIdDepto(-1);
        setIdCP();
        irAPagina0();
    }

    /* Modificacion de estado */   
    const mergeState = (datos) => {
        console.log("programando setstate")
        setState(prevState => ({...prevState, ...datos}));        
    }

    const mergeEstadoFinal = (datos) => {        
        console.log ("datos")
        console.log(datos)

        console.log ("state")
        console.log(state)

        setEstadoFinal({...state, ...datos, 
            piso:state.selPisos,
            
            personas_cerca:state.selPersonasCerca,
            id_municipio:state.selMun,
            material_construccion: state.selMateriales,
            perdida_estabilidad: state.selEquilibrio,
            intensidad_sentida: state.selIntensidades,
            id_departamento: state.selDepto,
            id_centro_poblado: state.selCentroPob,
            dano_construccion: state.dano,
            id_sismo: idSismo});
    }

    const enviar = async ()=> {
        const urlEnvio = urlBaseRest + "guardar_formulario";
        console.log("enviando formulario a " + urlEnvio)
        console.log("estadoFinal");
        console.log(estadoFinal);
        
        const res = await axios.post(
            urlEnvio, {
                datoControl:"valor",
                estado: estadoFinal
            }        
        ).catch(function (error) {
            console.log("error al guardar")
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            console.log(error.config);
        });
        
        if (res && res.data) {
            console.log ("res.data")
            console.log (res.data)
            if ( res.data.status == "insercion_exitosa") {
                console.log ("res.data2")
                console.log (res.data)

                setIdPagina(100);            
            } else {
                console.log("error al guardar")
                console.log(res.data)
            }
        }
    }

    /* Efectos */
    useEffect(()=>{
        console.log("idSismo " + idSismo);
    }, [idSismo]);

    useEffect(()=>{
        console.log("state ha cambiado");
        console.log(state);
    }, [state]);

    useEffect(()=>{                        
        if (estadoFinal && Object.keys(estadoFinal).length > 0 ) {                        
            // limpiar valores
            estadoFinal.actividad = parseInt(estadoFinal.actividad);
            estadoFinal.selPersonasCerca = parseFloat(estadoFinal.selPersonasCerca);
            
            console.log("enviando estado final");
            enviar();
        }
        
    }, [estadoFinal]);
    
    /* Navegacion */           
    //console.log("ir a " + idPagina);

    const paginas =[
        {id:-1, componente:<PaginaArchivos/>},
        {id:0, componente: <Pagina0 
        setState={mergeState}
        avanzarPagina={avanzarPagina} 
        irASelectorResultados={irASelectorResultados}
        irAPaginaAlterna={irAPaginaAlterna} 
        setIdSismo={setIdSismo}/>},
        
        {id:1, componente: <Pagina1
            avanzarPagina={avanzarPagina}
            retrocederPagina={retrocederPagina}        
            direccion={direccion}
            setDireccion={setDireccion}
            setState={mergeState}
            state={state}
            idDepto={idDepto}            
            setIdDepto={setIdDepto}
            idDeptoRef={idDeptoRef}
            idMun={idMun}
            idMunRef={idMunRef}
            setIdMun={setIdMun}
            idCP={idCP} 
            setIdCP={setIdCP}
            />
        },
        {id:2, componente: <Pagina2 
            avanzarPagina={avanzarPagina}
            retrocederPagina={retrocederPagina}
            setPagina={setIdPagina}
            setPiso={setPiso}
            setState={mergeState}
            state={state} />},
        {id:3, componente: <Pagina3
            avanzarPagina={avanzarPagina}
            retrocederPagina={retrocederPagina}
            setPiso={setPiso}
            setState={mergeState}
            state={state} />},
        {id:4, componente:<Pagina4
            avanzarPagina={avanzarPagina}
            retrocederPagina={retrocederPagina}
            setPiso={setPiso}
            mergeEstadoFinal={mergeEstadoFinal}
            setState={mergeState}
            state={state} />},
        {id:100, componente: <Gracias reiniciarFormulario={reiniciarFormulario}/>},
        {id:"1b", componente:<Pagina1b 
        avanzarPaginaAlt={avanzarPaginaAlt}
        retrocederPaginaAlt={irAPagina0}
        setState={mergeState}
        state={state}/>},
        
        {id:"NAV_SELECTOR_RESULTADOS_SISMO", 
        componente: <SelectorResultadosSismo
            irAPagina0={irAPagina0}
            irAConsultaSitio={irAConsultaSitio}/>},
        
        {id:NAV_CONSULTA_SITIO, componente:<ConsultaPorSitio irAPagina0={irAPagina0} />},                
    ];   

    return (
        buscarPagina(idPagina, paginas)
    )
}